import {IVideoSlidesRuleConfig} from "../../../configurations/config-data-sections/arenas.configuration";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {GameInfo} from "../../../games/game-info";
import {ISlideRuleModel} from "./slide-rule-model.interface";
import {VideoStreamSlideRuleModel} from "./video-stream-slide-rule.model";
import {LiveStreamVideoSlideRuleModel} from "./live-stream-video-slide-rule.model";
import {BannerSlideRuleModel} from "./banner-slide-rule.model";
import {ISlideRenderer} from "../../video-slides.service.interface";

export class SlidesRulesHandler {
    constructor(private readonly services: IServiceFactoryExtended,
                slidesRulesConfig: IVideoSlidesRuleConfig[],
                gamesWithVideoStream: GameInfo[],
                gamesWithLiveStream: GameInfo[]) {

        slidesRulesConfig.forEach(ruleConfig => {
            switch (ruleConfig.category) {
                case "videoStream":
                    this._rules.push(new VideoStreamSlideRuleModel(ruleConfig, gamesWithVideoStream, services));
                    break;
                case "liveStream":
                    this._rules.push(new LiveStreamVideoSlideRuleModel(ruleConfig, gamesWithLiveStream, services));
                    break;
                case "banner":
                    this._rules.push(new BannerSlideRuleModel(services));
                    break;
                default:
                    this.services.logger.error(`Can't handle slide rule category ${ruleConfig.category}`);

            }
        })
    }

    private readonly _rules: ISlideRuleModel[] = [];

    createRenderers(): ISlideRenderer[] {
        let result: ISlideRenderer[] = [];
        let shouldContinue = true;

        do {

            let currentChunk: ISlideRenderer[] = [];

            this._rules.forEach(rule => {
                currentChunk = rule.appendToChunk(currentChunk);
            });

            result = [  ...result,
                ...currentChunk
            ]

            shouldContinue = currentChunk.length > 0;

        } while (shouldContinue);

        return result;
    }

}